module.exports = __webpack_public_path__ + "img/about-red.b90c92fa.png";